var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Col, Row } from '../../../Grid';
import { AutocompleteItem } from './autocomplete-item';
export var AutocompleteSelected = function (_a) {
    var displayKey = _a.displayKey, selectedKey = _a.selectedKey, selected = _a.selected;
    if (!selected)
        return null;
    return _jsx(_Fragment, { children: _jsx(Row, __assign({ noWrap: true, ellipsis: true, overflowWrap: "normal" }, { children: _jsx(Col, __assign({ fullWidth: true, center: true }, { children: _jsx(AutocompleteItem, { displayKey: selectedKey || displayKey, option: selected }) })) })) });
};
